import { useState } from 'react'

export type EmailExportModalParams = {
    exportByEmailOpen: boolean
    onExportByEmailClose: () => void
    onExportByEmailSuccess: () => void
    reportGenerationOpen: boolean
    onReportGenerationClose: () => void
    onExportByEmailOpen: () => void
}

export const useEmailExportModalParams = (): EmailExportModalParams => {
    const [exportByEmailOpen, setExportByEmailOpen] = useState(false)
    const [reportGenerationOpen, setReportGenerationOpen] = useState(false)

    const handleExportByEmailClose = () => {
        setExportByEmailOpen(false)
    }

    const handleReportGenerationClose = () => {
        setReportGenerationOpen(false)
    }

    const handleExportByEmailSuccess = () => {
        setExportByEmailOpen(false)
        setReportGenerationOpen(true)
    }

    const handleExportByEmailOpen = () => {
        setExportByEmailOpen(true)
    }

    return {
        exportByEmailOpen,
        onExportByEmailClose: handleExportByEmailClose,
        onExportByEmailSuccess: handleExportByEmailSuccess,
        reportGenerationOpen,
        onReportGenerationClose: handleReportGenerationClose,
        onExportByEmailOpen: handleExportByEmailOpen,
    }
}
